/*------------------------------------*\
    MODULES
\*------------------------------------*/
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import 'whatwg-fetch';

/*------------------------------------*\
    IMAGE GALLERY
\*------------------------------------*/
class ImageGallery {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.button = self.elem.querySelector('[data-button]');
        self.galleryId = self.elem.getAttribute('data-gallery-id');
    }

    init() {
        let self = this;

        self.elem.addEventListener('click', evt => {
            evt.preventDefault();

            // Disable the link
            self.elem.classList.add('is-disabled');
            self.elem.removeAttribute('href');
            self.button.textContent = 'Loading...';

            // Fetch the gallery images
            fetch(`/api/image-gallery/${self.galleryId}.json`)
                .then(function (response) {
                    return response.json();
                }).then(function (json) {
                    // Open the gallery
                    self.openGallery(json);
                }).catch(function (ex) {
                    console.log('Parsing failed', ex);
                });
        });
    }

    openGallery(data) {
        let self = this;

        self.elem.addEventListener('lgAfterOpen', () => {
            // Re-enable the link
            self.elem.classList.remove('is-disabled');
            self.elem.setAttribute('href', '#');
            self.button.textContent = self.button.getAttribute('data-button');
        });

        const dynamicGallery = lightGallery(self.elem, {
            dynamic: true,
            dynamicEl: data,
            plugins: [lgZoom, lgThumbnail],
            thumbnail: true,
            thumbMargin: 14,
            thumbWidth: 88,
            thumbHeight: '64px',
            download: false
        });

        dynamicGallery.openGallery();
    }
}

export default ImageGallery;